import React, { useEffect } from "react";
import { findCreateUserRequestByIdEvent } from "../../_events/create_user_request/find.event";
import { alertError } from "../../_utils/alerts";
import { useQuery } from "../../_utils/url_query_hook";

export const useCreateUserRequest = () => {

    const query = useQuery();
    const uuid = query.get("request");

    const [data, setData] = React.useState(null);
    const [loading, setLoading] = React.useState(false);

    const loadData = (id) => {
        setLoading(true);
        findCreateUserRequestByIdEvent(id)
        .then(json => {
            setData(json.data);
            setLoading(false);
        })
        .catch(err => {
            alertError(err.message);
            setLoading(false);
        });
    }

    useEffect(() => {
        loadData(uuid);
    }, [uuid]);

    return { data, loading };
}